import {
    PACKAGES_CREATE_EDIT_OPEN_MODAL,
    PACKAGES_CREATE_PACKAGE_REQUEST,
    PACKAGES_CREATE_PACKAGE_RESULT,
    PACKAGES_UPDATE_PACKAGE_REQUEST,
    PACKAGES_UPDATE_PACKAGE_RESULT,
    PACKAGES_GET_PACKAGE_REQUEST,
    PACKAGES_GET_PACKAGE_RESULT,
} from 'Redux/actionTypes';

export const packagesGetPackageRequest = (data) => ({
    type: PACKAGES_GET_PACKAGE_REQUEST,
    payload: data
})

export const packagesGetPackageResult = (data) => ({
    type: PACKAGES_GET_PACKAGE_RESULT,
    payload: data
})

export const packagesCreateEditOpenModal = (data) => ({
    type: PACKAGES_CREATE_EDIT_OPEN_MODAL,
    payload: data
})

export const packagesCreatePackageRequest = (data) => ({
    type: PACKAGES_CREATE_PACKAGE_REQUEST,
    payload: data
})

export const packagesCreatePackageResult = (data) => ({
    type: PACKAGES_CREATE_PACKAGE_RESULT,
    payload: data
})

export const packagesUpdatePackageRequest = (data) => ({
    type: PACKAGES_UPDATE_PACKAGE_REQUEST,
    payload: data
})

export const packagesUpdatePackageResult = (data) => ({
    type: PACKAGES_UPDATE_PACKAGE_RESULT,
    payload: data
})